module.exports = __webpack_public_path__ + "static/media/DeleteTrash.8b55eb8a.svg";